export default [
  {
    path: '/admin/warehouses',
    name: 'warehouse',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/warehouse/index.vue')
  },
]
